import * as React from 'react'

import { Box, Button, List, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  label?: string | null
  isDisabled: boolean
  onDelete: () => void
}

const Item: React.FC<Props> = ({ label, isDisabled, onDelete }) => {
  const [open, toggle] = useToggle(false)

  const button = (
    <Button disabled={isDisabled} type="secondary" onClick={onDelete} iconName="delete" />
  )

  return (
    <List.Item>
      <Box width="full" paddingRight="s8" overflowY="hidden">
        <Text.Normal color="grey800" size="300" weight="medium" ellipsis>
          {label}
        </Text.Normal>
      </Box>
      {isDisabled ? (
        <Tooltip.Dialog
          attachment="bottom center"
          open={open}
          toggle={toggle}
          label={i18n.t('job_catalog.no_delete_legal_entity')}
        >
          {button}
        </Tooltip.Dialog>
      ) : (
        button
      )}
    </List.Item>
  )
}

export default Item
